import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { useHistory } from "react-router-dom";
import ListAdminButtons from "../Common/ListAdminButtons";
import axios from "axios";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { userServices } from "../../Services/user.service";
import Tooltip from "../../Components/Common/Tooltip";
import { globalServices } from "../../Services";
import SpinnerLoading from "../Common/SpinnerLoading";
import { roles } from "../../Config/Roles";
import { AuthContext } from "../../Contexts/AuthContext";

const StoresTab = ({ url, tenantId, userId }) => {
  const { t: translator } = useTranslation();
  const { roleId } = useContext(AuthContext);
  const { cashier, accountant, manager, owner } = roles;
  const { updateLocTab, locTab, isMobile } = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const { register, handleSubmit, errors } = useForm();
  const [stores, setStores] = useState([]);
  const [storeId, setStoreId] = useState(undefined);
  const [storeTenant, setStoreTenant] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isHidden, setIsHidden] = useState(true);
  const [tenantStore, setTenantStore] = useState("");

  useEffect(() => {
    if (locTab === "stores") {
      tenantId
        ? axios
            .put(url, {
              tenantId: Number(tenantId),
              searchText: "",
              sortName: "Tag",
              pageIndex: 0,
              pageSize: 0,
              isAsc: true,
            })
            .then(res => setData(res.data.stores))
            .catch(err => console.log(err.response))
        : axios.get(url).then(res => setData(res.data.data));

      globalServices
        .getTenants(userId, "")
        .then(res => setStoreTenant(res.data))
        .catch(err => console.log(err));
    }
  }, [stores, locTab]);

  useEffect(() => {
    if (locTab === "stores") {
      setIsLoading(true);
      globalServices
        .getStoresByTenantId(tenantStore)
        .then(res => {
          let myArray = res.data.filter(
            ar => !data.find(rm => rm.storeId === ar.id),
          );
          setStores(myArray);
          setIsLoading(false);
        })
        .catch(err => console.log(err));
    }
  }, [tenantStore, locTab]);

  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "tag",
      text: translator("Store-Tab-Tag"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "description",
      text: translator("Store-Tab-Description"),
    },
    {
      dataField: "tenantName",
      text: translator("Store-Tab-Tenant"),
    },
    {
      dataField: "city",
      text: translator("Store-Tab-City"),
      hidden: Boolean(isMobile),
    },
  ];

  const options = { custom: true, totalSize: data.length, sizePerPage: 8 };

  const handleToAdd = () => {
    tenantId === false ? setShow(true) : history.push(`/store-add`);
  };

  const handleAddUserToStore = () => {
    userServices
      .addUserToStore(userId, storeId)
      .then(res => axios.get(url).then(res => setData(res.data.data)))
      .catch(err => console.log(err));

    setShow(false);
  };

  const handleAddTenantToStore = () => {};

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      updateLocTab("tenants");
      history.push(`/stores/${row.storeId}`);
    },
  };

  return (
    <>
      <div className="p-2">
        <div className="container-fluid p-0">
          <div className="card-body pl-0 mb-4">
            <ToolkitProvider
              keyField="storeId"
              data={data}
              columns={columns}
              search>
              {props => (
                <div>
                  <SearchBar
                    placeholder={translator("Stores-Tab-Search")}
                    {...props.searchProps}
                  />{" "}
                  <Tooltip text={translator("Tabs-Search")} />
                  <ListAdminButtons
                    handleToAdd={
                      [cashier, accountant, manager, owner].includes(
                        Number(roleId),
                      )
                        ? null
                        : handleToAdd
                    }
                  />
                  <PaginationProvider pagination={paginationFactory(options)}>
                    {({ paginationProps, paginationTableProps }) => (
                      <div>
                        {isLoading && (
                          <div className="dashboard-card-spinner">
                            <SpinnerLoading />
                          </div>
                        )}
                        {!isLoading && (
                          <BootstrapTable
                            keyField="storeId"
                            data={data}
                            loading
                            columns={columns}
                            rowEvents={rowEvents}
                            classes={"table-sm"}
                            rowClasses="boostrap-table-row"
                            noDataIndication={translator("No-Data")}
                            {...paginationTableProps}
                            {...props.baseProps}
                          />
                        )}

                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    )}
                  </PaginationProvider>
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>

      <Modal show={show} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>
            {tenantId === false
              ? translator("StoreTab-AddUserToStore")
              : translator("StoreTab-AddTenantToStore")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col-sm-12">
            <p>{translator("StoreTab-Modal-Tenant")}</p>
            {storeTenant.length > 0 ? (
              <select
                placeholder={translator("SelectStoreTag")}
                name="storeId"
                className="form-control"
                ref={register({
                  validate: value => value !== "-1",
                })}
                onChange={event => {
                  setIsHidden(false);
                  setTenantStore(event.target.value);
                }}>
                <option value="-1">{translator("SelectStoreTag")}</option>
                {storeTenant &&
                  storeTenant.map(e => <option value={e.id}>{e.name}</option>)}
              </select>
            ) : (
              <p>{translator("No-Data")}</p>
            )}

            {errors.storeId && errors.storeId.type === "validate" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
          </div>
          <div className="form-group col-sm-12" hidden={isHidden}>
            <p>{translator("POS-List-Store")}</p>

            <select
              placeholder={translator("SelectStoreTag")}
              name="storeId"
              className="form-control"
              ref={register({
                validate: value => value !== "-1",
              })}
              onChange={event => {
                setStoreId(event.target.value);
              }}>
              <option value="-1">{translator("SelectStoreTag")}</option>

              {stores ? (
                stores.map(e => <option value={e.id}>{e.name}</option>)
              ) : (
                <p>{translator("No-Data")}</p>
              )}
            </select>
            {errors.storeId && errors.storeId.type === "validate" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-outline-secondary"
            onClick={() => setShow(false)}>
            {translator("Btn-Cancel")}
          </button>
          {storeTenant.length != 0 ? (
            <button
              onClick={handleSubmit(
                tenantId === false
                  ? handleAddUserToStore
                  : handleAddTenantToStore,
              )}
              type="button"
              className="btn btn-primary">
              {tenantId === false
                ? translator("StoreTab-AddUserToStore")
                : translator("StoreTab-AddTenantToStore")}
            </button>
          ) : (
            ""
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StoresTab;
